const keyword = {
  additionalPaymentInfo: 'Additional information',
  advertisement: 'Advertisement',
  appStore: 'App store',
  appointmentType: 'Appointment type',
  ariaLabelControls: 'Carousel controls',
  back: 'Back',
  cameraPermissionDenied: 'Camera permission denied',
  cashPayment: 'Cash payment',
  category: 'category',
  choose: 'choose',
  city: 'City',
  clock: 'o\'clock',
  close: 'Close',
  companyInfo: 'Address supplement/company',
  delivery: 'Delivery',
  deliveryConditions: 'Delivery conditions',
  deliveryInactive: 'Collection',
  deliveryMethods: 'Delivery methods',
  emergencyService: 'Emergency service',
  errorHasOccurred: 'An error has occurred.',
  expressDelivery: 'Express-Delivery',
  filter: 'filter',
  filter2: 'Filter',
  firstName: 'First name',
  free: 'free',
  googlePlay: 'Google play',
  here: 'here',
  houseNumber: 'House number',
  insteadOf: 'instead of',
  lastName: 'Last name',
  magazines: 'magazines',
  manufacturer: 'manufacturer',
  medicine: 'medicine',
  medicines: 'medicines',
  menu: 'menu',
  messengerService: 'Messenger service',
  more: 'more',
  myLife: 'my life E-paper',
  no: 'No',
  note: 'Remark',
  offers: 'offers',
  on: 'on',
  onlinePayment: 'Online payment',
  onsitePayment: 'Payment on site',
  open: 'Open',
  openingHours: 'Opening hours',
  orders: 'orders',
  owner: 'Owner',
  password: 'password',
  paymentLogos: 'Payment logos',
  paymentMethods: 'Payment methods',
  pharmacy: 'pharmacy',
  pickup: 'pickup',
  phoneNumber: 'Phone number',
  product: 'product',
  productCarousel: 'Product carousel',
  products: 'products',
  register: 'Register',
  registration: 'registration',
  remarks: 'Remarks',
  salutation: 'Salutation',
  search: 'Search',
  serviceOffering: 'Service offering',
  partnerPrograms: 'Partner Programs',
  shoppingCart: 'Shopping cart',
  signIn: 'Anmelden',
  signOut: 'Sign out',
  slide: 'Slide',
  street: 'Street',
  toCart: 'to cart',
  today: 'today',
  use: 'use',
  user: 'User',
  userData: 'User data',
  whatsApp: 'WhatsApp',
  yes: 'Yes',
}

export default keyword
